import { InjectionToken } from '@angular/core';
import { Language } from '../types/language.type';

export const LANGUAGES = new InjectionToken<Language[]>('Supported languages', {
  factory: () => [
    { name: 'English', abbr: 'en', flag: 'flag-english' },
    { name: 'Nederlands', abbr: 'nl', flag: 'flag-dutch' }
  ]
});
